var React = require('react');

function SeparatorInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n\t\t\t.sep-1 {\n\t\t\t\tfill: #f7f7f7;\n\t\t\t\tstroke: #f7f7f7;\n\t\t\t\tstroke-miterlimit: 10;\n\t\t\t\tstroke-width: 0.25px;\n\t\t\t}\n\t\t")),React.createElement("title",{"key":1},"Sans titre - 1"),React.createElement("polygon",{"className":"sep-1","points":"0.1 0.1 300.1 15.1 0.1 15.1 0.1 0.1","key":2})]);
}

SeparatorInline.defaultProps = {"id":"Vague_1","data-name":"Vague 1","viewBox":"0 0 300.1 15.3"};

module.exports = SeparatorInline;

SeparatorInline.default = SeparatorInline;
